module.exports = __webpack_public_path__ + "media/images/edgar_zangado-30ba97ceb4f6c8be6cf6ae680c9d8fde.png";